import React from "react";
import { Quote, Star } from "lucide-react";
import { TESTIMONIALS } from "@/lib/content";

export default function Testimonials() {
  return (
    <section id="testimonials" className="py-20 sm:py-28 bg-[#F6F2EB]/60">
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <div className="mb-12 text-center">
          <div className="eyebrow mb-3">In their words</div>
          <h2 className="font-serif text-4xl sm:text-5xl text-[#0B302F] tracking-tight">
            Quiet shifts, gently noticed.
          </h2>
          <p className="mt-4 text-[#0B302F]/70 max-w-2xl mx-auto">
            A few notes from the people we have walked beside.
          </p>
        </div>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-5 [column-fill:_balance]">
          {TESTIMONIALS.map((t, i) => (
            <article
              key={t.id}
              data-testid={`testimonial-${t.id}`}
              className={`relative mb-5 break-inside-avoid p-6 sm:p-7 rounded-3xl border border-[#EAE4DA] ${
                i % 2 === 0 ? "bg-white" : "bg-[#F9EAE8]/50"
              } hover:border-[#D5B876] transition-colors duration-300`}
            >
              <Quote className="h-6 w-6 text-[#D5B876]" strokeWidth={1.4} />
              <p className="mt-4 text-[#0B302F]/85 font-serif text-lg leading-relaxed italic">
                “{t.body}”
              </p>
              <div className="mt-6 pt-5 border-t border-[#EAE4DA] flex items-center justify-between">
                <div>
                  <div className="font-sans text-sm font-medium text-[#0B302F]">{t.name}</div>
                  <div className="text-[11px] tracking-[0.18em] uppercase text-[#2A5C5A] mt-0.5">
                    {t.role}
                  </div>
                </div>
                <div className="flex gap-0.5" aria-label={`${t.rating} out of 5`}>
                  {Array.from({ length: 5 }).map((_, idx) => (
                    <Star
                      key={idx}
                      className={
                        idx < t.rating
                          ? "h-3.5 w-3.5 text-[#D5B876] fill-[#D5B876]"
                          : "h-3.5 w-3.5 text-[#D5B876]/40"
                      }
                      strokeWidth={1.2}
                    />
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
